import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ spacing }) => ({
    ui_icon_status: {
        borderRadius: spacing(6),
        height: spacing(12),
        padding: spacing(1),
        width: spacing(12),
    },
    "ui_icon_status--error": {
        backgroundColor: "#FCEBF1",
    },
    "ui_icon_status--success": {
        backgroundColor: "#F3F5FB",
    },
}));
//# sourceMappingURL=ui_icon_status.css.js.map